/* Components */
export const GET_COMPONENTS= "GET_COMPONENTS"
export const GET_COMPONENTS_SUCCESS = "GET_COMPONENTS_SUCCESS"
export const GET_COMPONENTS_FAIL = "GET_COMPONENTS_FAIL"

export const POST_COMPONENT= "POST_COMPONENT"
export const POST_COMPONENT_SUCCESS = "POST_COMPONENT_SUCCESS"
export const POST_COMPONENT_FAIL = "POST_COMPONENT_FAIL"